exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pricing-table[data-v-488a6b9a] {\n  grid-template-columns: repeat(2, 1fr);\n  margin-top: 20px !important;\n}\n.pricing-table > .plan[data-v-488a6b9a] {\n  cursor: pointer;\n  border: solid 1px gainsboro;\n  border-radius: 5px;\n}\n.selected-plan[data-v-488a6b9a] {\n  border: 2px solid #0EDB6D !important;\n  -webkit-box-shadow: #0EDB6D 0px 0px 14px 0px !important;\n          box-shadow: #0EDB6D 0px 0px 14px 0px !important;\n}\n", ""]);

// exports
